import React from "react";
import {createPortal} from "react-dom";
import "./inspectionReportMatrix.css";

function InspectionReportEditModal({open, onClose, title, meta, children, size = "md", hideHeaderBorder = false}) {
    if (!open || typeof document === "undefined") {
        return null;
    }

    return createPortal(
        <div className="ir-modal-overlay" onClick={onClose} role="presentation">
            <div
                className={`ir-modal ir-modal--${size}`}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="ir-modal-title"
            >
                <header className={`ir-modal__header${hideHeaderBorder ? " ir-modal__header--flat" : ""}`}>
                    <div className="ir-modal__head-text">
                        <h3 id="ir-modal-title" className="ir-modal__title">{title}</h3>
                        {meta && <p className="ir-modal__meta">{meta}</p>}
                    </div>
                    <button type="button" className="ir-modal__close" onClick={onClose} aria-label="닫기">
                        ×
                    </button>
                </header>
                <div className={`ir-modal__body${size === "xl" || size === "lg" ? " ir-modal__body--flush" : ""}`}>{children}</div>
            </div>
        </div>,
        document.body,
    );
}

export {InspectionReportEditModal};
